// extracted by mini-css-extract-plugin
module.exports = {"title":"b_b","chart-navigation":"b_c","chart-navigation__left":"b_d","chart-navigation__right":"b_f"};